import { sortBy } from 'lodash';
import { RootState } from '..';

export const selectMixtureTypes = (state: RootState) =>
  sortBy(state.mixtureTypes.mixtureTypes, 'name');

export const selectMixtureTypeErrors = (state: RootState) =>
  state.mixtureTypes.errors;
